

















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class VirtualColleagueNavigation extends Vue {
    get links() {
        const items: Array<Record<string, any>> = [
            {
                label: 'Algemeen',
                route: { name: 'company_settings_virtual_colleague_general' },
            },
            {
                label: 'Leads aanmaken',
                route: { name: 'company_settings_virtual_colleague_triggered_referral' },
            },
            {
                label: 'Fase & Status bijhouden',
                route: { name: 'company_settings_virtual_colleague_realworks_status_rules' },
            },
            {
                label: 'Actie ondernemen',
                route: { name: 'company_settings_virtual_colleague_triggered_action' },
            },
            {
                label: 'Leads sluiten',
                route: { name: 'company_settings_auto_close_settings' },
            },
            {
                label: 'Omzet verwachting',
                route: { name: 'company_settings_turnover' },
            },
        ]

        if (this.$currentCompany.virtualColleagueAiEnabled) {
            items.push({
                label: 'A.I.',
                route: {
                    name: 'one_settings_virtual_colleague_ai',
                    params: {
                        toOne: 'true',
                    },
                },
            })
        }

        return items
    }

    get currentView() {
        return this.$route.name
    }
}
